/*eslint-disable*/ export const messages = JSON.parse("{\"textfield.label.optional\":[\"(valgfritt)\"]}");
//# sourceMappingURL=messages.mjs.map